import React, { Component } from 'react'
import { StyledQuestionsPageHeader, StyledScoreCard } from '../../styled/StyledQuestionComponents'
import { Col, Row, Grid, Checkbox } from 'rsuite'
import _ from 'lodash'
import Moment from 'react-moment'
import ScoreIcon from '../Icons/ScoreIcon';
import { QuestionAnswerEnum } from '../../../../../../enums/QuestionAnswerEnum';
import InformationIcon from "../Icons/InformationIcon";


class QuestionsPageHeader extends Component  {
    constructor(props) {
        super(props);
        this.state ={
            saved: false
        }
        this.checkSaved = this.checkSaved.bind(this)
        this.isCorrectAnswer = this.isCorrectAnswer.bind(this)
    }

    
  
    // verifica se a questão já possui resposta ou nao
    checkAnswers(questionCode) {

        const answer = this.props.answers
        if (_.isEmpty(answer)) {
            return !_.isEmpty(answer)
        } else {
            if (answer[questionCode] && answer[questionCode] !== '') {
                return !_.isEmpty(answer)
            }
            return false
        }

    }

     // verifica se a questão foi salva ou nao
    checkSaved(questionCode){
       const {savedQuestions} = this.props

       if (!!savedQuestions[questionCode]) {
           return true
       } else {
           return false
       }
    }
   // verifica se a resposta dada está correta ou nao
    isCorrectAnswer(question, answer){
       const type = question && question.type 
       const options = question && question.optionDTOs

       switch (type) {
            case 1: // CHOOSE ONE
               const correctAnswer = _.find(options, opt => opt.isCorrectAnswer).code           
       
               return (correctAnswer === answer)
                             
            case 2: //TRUTH_OR_FALSE
                return (
                    true
                )
            case 3: //OPEN_ANSWER
                return QuestionAnswerEnum.OPEN_ANSWER
       }
    }

    render(){       
   
        const currentQuestion = this.props.question
        const { isReview, questionaryInfo, answers, previousTriesDTO } = this.props

        if (_.isEmpty(previousTriesDTO) && isReview) return null
        
        const currentAnswer = answers[currentQuestion.code]
        const isAnswered = this.props.answers && this.checkAnswers(currentQuestion.code)   
        const maxCode = _.max(previousTriesDTO.map(t => t.code))
        const lastTry = _.find(previousTriesDTO, pre => pre.code === maxCode)

        return (
            <StyledQuestionsPageHeader>
                <Grid fluid>
                  {
                      isReview && 
                        <Row gutter={48} className={'review-header'}>
                          <div className={'info'}> 
                            <h1> Revisão - {questionaryInfo.title} </h1>
                                <span> <strong>Iniciado em: </strong> <Moment subtract={{ minutes: lastTry.timeSpent }} format="DD/MM/YYYY HH:mm">{lastTry.submissionDate}</Moment> </span> 
                                <span> <strong>Concluído em: </strong>  <Moment format="DD/MM/YYYY HH:mm">{lastTry.submissionDate}</Moment> </span>
                                <span> <strong>Tempo empregado: </strong>{lastTry.timeSpent} min.  </span>
                          </div> 
                            <StyledScoreCard >
                                <div className={'icon'}>
                                     <ScoreIcon width={60} />
                                </div>
                                <div className={'score'}>
                                    <span className={'text'}> nota </span>
                                    <span> <strong> {lastTry.grade}</strong>/{lastTry.value}pts </span>
                                </div>

                            </StyledScoreCard>
                        </Row>
                  }
                    <Row gutter={48} className={'questions-header'}>
                        <Col className={'question-info'} md={7} lg={7}>
                            <span className={'info'}>Questão {currentQuestion.order}: </span>
                            
                            <span>
                                {
                                   isReview ? 
                                       this.isCorrectAnswer(currentQuestion, currentAnswer)    ?
                                        QuestionAnswerEnum.CORRECT
                                        :
                                        QuestionAnswerEnum.INCORRECT
                                   :
                                   isAnswered  ?
                                     'Respondida' :
                                     'Sem resposta'
                                }
                            </span>
                        </Col>
                        <Col className={'question-info'} md={6} lg={6}>
                        {
                               isReview ? 
                               <div>
                                <span className={'info'}>Pontuação: </span>
                               { 
                                     this.isCorrectAnswer(currentQuestion, currentAnswer) ? 
                                                <span>{currentQuestion.value}/{ currentQuestion.value }pts</span>
                                     :
                                                <span>0/{ currentQuestion.value }pts</span>
                               }
                                </div> 
                               :
                               <div>
                                <span className={'info'}>Valor: </span>
                                <span>{currentQuestion.value},00 ponto(s)</span> </div>
                        }
                            
                        </Col>
                        <Col className={'save-question'} md={11} lg={11}>      
                            {
                                isReview ?
                                    this.checkSaved(currentQuestion.code) ?
                                     <span>Questão Salva</span>
                                     :
                                     ''
                                :
                                     <Checkbox onChange={() => this.props.saveQuestion(currentQuestion.code)} checked={this.checkSaved(currentQuestion.code)}> Marcar questão para revisão.
                                         <span style={{ marginLeft:'10px' }}  title={'As questões salvas estarão destacadas na revisão do simulado.'}> <InformationIcon width={16} /></span>
                                     </Checkbox>

                             }
                        </Col>
                    </Row>
                </Grid>
            </StyledQuestionsPageHeader>
        )
    }
}

export default QuestionsPageHeader







// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/Questions/QuestionPageHeader.js